import * as React from 'react';
import {
    BackNextSkip,
    TextInput,
    required,
    isValidAmount,
    clearValidation,
    ruleRunner,
    run,
} from '@assetmark/common-elements';

import {
    currencyFormatter,
    convertdollarStringtoNumber,
} from '@assetmark/utilities';
import { IProfile } from '../../profileComponent';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './investmentAmount.module.css';

export interface InvestmentProps {
    onNextButtonClick: (event: any, data: any) => void;
    onBackButtonClick: (event: any, data: any) => void;
    data?: IProfile;
}

interface InvestmentState {
    validationErrors: any;
    buttonClass: string;
    showErrors: boolean;
    investmentInfo: any;
    isInvestmentAmountValid: boolean;
    investmentAmount: string;
}

const fieldValidations = {
    InvestmentAmount: ruleRunner('InvestmentAmount', 'amount', [
        required,
        isValidAmount(10000, 999999999),
    ]),
};

export class InvestmentAmount extends React.Component<
    InvestmentProps,
    InvestmentState
> {
    constructor(props) {
        super(props);

        const isInvestmentAmountValid = this.isInvestmentAmountValid({
            InvestmentAmount: this.props.data.investmentInfo.InvestmentAmount,
        });

        this.state = {
            investmentInfo: {
                InvestmentAmount: this.props.data.investmentInfo.InvestmentAmount,
            },
            validationErrors: {},
            // buttonClass: isInvestmentAmountValid ? '' : 'disabled',
            buttonClass: '',
            showErrors: false,
            isInvestmentAmountValid,
            investmentAmount: currencyFormatter(
                this.props.data.investmentInfo.InvestmentAmount,
            ),
        };

        this.onInvestmentAmountChange = this.onInvestmentAmountChange.bind(this);
        this.validateInvestmentAmount = this.validateInvestmentAmount.bind(this);
        this.updateInvestmentAmount = this.updateInvestmentAmount.bind(this);
    }

    public onInvestmentAmountChange(e) {
        this.validateInvestmentAmount(e.target.name, true);

        const tempInvestmentInfo = { ...this.state.investmentInfo };
        tempInvestmentInfo.InvestmentAmount = convertdollarStringtoNumber(
            e.target.value,
        );
        this.setState({
            investmentInfo: tempInvestmentInfo,
            investmentAmount: currencyFormatter(e.target.value),
        });

    }

    public render() {
        return (
            <div className={`${styles.investment_amount_component} col-sm-12`}>
                <h1 className={`${styles.title}`}>Investment Amount</h1>

                <div className="row">
                    <div className={`col-sm-12 ${styles.label_text}`}>
                        I have $
            <TextInput
                            name="InvestmentAmount"
                            maxLength={11}
                            className={`${styles.line_1} investment-amount ${styles.nametext} ${this.state.validationErrors.InvestmentAmount && this.state.validationErrors.InvestmentAmount.length ? styles.errorlineinput : ''}`}
                            type="underline"
                            value={
                                this.state.investmentInfo.InvestmentAmount
                                    ? this.state.investmentAmount
                                    : ''
                            }
                            onChange={this.onInvestmentAmountChange}
                            onBlur={this.onBlurInvestmentAmount}
                            showError={this.state.showErrors}
                            errorText={this.state.validationErrors.InvestmentAmount || ''}
                        />
            to invest
          </div>
                </div>
                <div className={styles.mt_row_btn}>
                    <BackNextSkip
                        backButtonClassName={`button button-secondary button-lg ${styles.lineHeightClass}`}
                        nextButtonClassName={`button button-primary button-lg ml-2 ${this.state.buttonClass} ${styles.lineHeightClass}`}
                        onNextButtonClickHandler={(e) =>
                            this.updateInvestmentAmount(e, 'next')
                        }
                        onBackButtonClickHandler={(e) =>
                            this.updateInvestmentAmount(e, 'back')
                        }
                        isDisabledNextButton={(this.state.investmentInfo.InvestmentAmount < 10000 || this.state.investmentInfo.InvestmentAmount > 999999999) ? true : false}
                    />
                </div>
            </div>
        );
    }

    private clearValidation = (field: any) => {
        return [ruleRunner(field, '', [clearValidation])];
    };

    private updateInvestmentAmount = (e: any, clickHandler): void => {
        const tempProfile = this.props.data;
        tempProfile.investmentInfo = this.state.investmentInfo;
        if (
            this.isInvestmentAmountValid(
                this.state.investmentInfo,
                this.state.validationErrors,
            )
        ) {
            if (clickHandler === 'back') {
                this.props.onBackButtonClick(e, tempProfile);
            } else if (clickHandler === 'next') {
                this.props.onNextButtonClick(e, tempProfile);
            }
        } else if (clickHandler === 'back') {
            this.props.onBackButtonClick(e, tempProfile);
        }
    };

    // goes through validation errors and investment amount and returns true or false based on the data
    private isInvestmentAmountValid = (
        investment?: any,
        validationErrors?: any,
    ): boolean => {
        let errorOnPage = false;
        let returnItem = false;

        if (
            validationErrors &&
            validationErrors.InvestmentAmount &&
            validationErrors.InvestmentAmount.length > 0
        ) {
            errorOnPage = true;
        }
        if (
            investment.InvestmentAmount &&
            investment.InvestmentAmount >= 10000 &&
            investment.InvestmentAmount <= 999999999 &&
            errorOnPage === false
        ) {
            returnItem = true;
        }

        return returnItem;
    };

    // when text input loses focus
    private onBlurInvestmentAmount = (e: any): void => {
        const field = e.target.name;
        return this.validateInvestmentAmount(field, false);
    };

    // make sure input is the valid amount
    private validateInvestmentAmount = (field: any, onChange: boolean) => {
        const currentInvestment = this.state.investmentInfo;
        const validationErrors = onChange
            ? run(currentInvestment, this.clearValidation(field))
            : run(currentInvestment, [fieldValidations[field]]);

        const updatedValidationErrors = {
            ...this.state.validationErrors,
            ...validationErrors,
        };
        const isInvestmentAmountValid = this.isInvestmentAmountValid(
            currentInvestment,
            validationErrors,
        );

        return this.setState({
            investmentInfo: currentInvestment,
            validationErrors: updatedValidationErrors,
            // buttonClass: isInvestmentAmountValid ? '' : 'disabled',
            showErrors: true,
        });
    };
}
